import React from 'react';

const SalePerson: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Sale Persons</h1>
          <p className="text-gray-600 mt-2">
              Sale Persons
          </p>
        </div>



        {/* Main Users Image */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="mb-6">
            <img
              src="/images/settings/salespersons/saleperson.png"
              alt="Sales Persons Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Add Custom Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Add Sale Person</h2>
          <p className="text-gray-600 mb-4">
            Sale Person
          </p>
          <p className="text-gray-600 mb-4">
            To add a saleperson:
          </p>
          <ol className="list-decimal list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings</li>
            <li>Select Sales Persons</li>
            <li>Click the New Sale Persons button in the top right corner of the page.</li>
            <li>Fill the information about Sale Person</li>
            <li>Click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/salespersons/saleperson-new.png"
              alt="Add Sales Persons Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Edit Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Edit Taxes</h2>
          <p className="text-gray-600 mb-4">
          After you have added a new sales persons, you can edit their data if required. Here’s how:
          </p>
          <ol className="list-disc list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings </li>
            <li>Select the sale person you want to edit and click down arrow button</li>
            <li>Click Edit.</li>
            <li>Make the required changes and click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/salespersons/saleperson-edit.png"
              alt="Add Custom Currency Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
          <div className="mb-6  mt-6">
            <img
              src="/images/settings/salespersons/saleperson-edit-save.png"
              alt="Currency Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>



      </div>

    </div>
  );
};

export default SalePerson;
